//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { UserService } from "@nuskin/ns-account";
import { StringService } from "@nuskin/ns-util";
import { CurrencyService } from "@nuskin/ns-shop";
import { NsIcon } from "@nuskin/design-components";
import VClamp from "vue-clamp";

export default {
  name: "NsSearchbarList",
  components: { NsIcon, VClamp },
  props: {
    hideAddToBag: Boolean,
    hideSeeMoreResults: Boolean,
    language: {
      type: String,
      default: ""
    },
    market: {
      type: String,
      default: ""
    },
    mode: {
      type: String,
      default: ""
    },
    pricesLoading: Boolean,
    searchData: {
      type: Array,
      default: function() {
        return [];
      }
    },
    showMoreButton: Boolean,
    showPricingInPredictive: Boolean,
    title: {
      type: String,
      default: ""
    },
    translations: {
      type: Object,
      default: function() {
        return {};
      }
    },
    // one of "recent", "popular", "predictive"
    type: {
      type: String,
      default: ""
    }
  },
  data: function() {
    return {
      PSVString: "SV",
      user: UserService.getUser()
    };
  },
  computed: {
    typeClass() {
      return this.type;
    }
  },
  mounted() {
    StringService.getStrings([{ key: "psvDist", dflt: "SV" }]).then(strings => {
      this.PSVString = strings.psvDist;
    });
  },
  methods: {
    displaySku(item) {
      return item.agelocme ? item.agelocme.code : item.sku;
    },
    formatPrice(price) {
      return CurrencyService.format(price, this.market, this.language);
    },
    formatPV(pv) {
      if (typeof pv === "number") {
        return "&bull; " + this.PSVString + ":" + pv;
      } else {
        return "";
      }
    },
    getAgelocData(item) {
      return item.agelocme ? JSON.stringify(item.agelocme) : "";
    },
    hasSKU(item) {
      return typeof item.sku !== "undefined";
    },
    hasUser() {
      return this.user && this.user.id;
    },
    imgError(e) {
      e.target.classList.add("error-loading");
    },
    imgLoad(e) {
      e.target.classList.remove("error-loading");
    },
    isExclusiveOffer(item) {
      return item.isExclusive === "true" || item.isExclusive === true;
    },
    notBaseSKU(item) {
      return item.sku.substring(2, 4) !== "55";
    },
    showAddToCart(item) {
      return this.hasSKU(item) && this.notBaseSKU(item) && !this.hideAddToBag;
    },
    showPVInPricing() {
      return this.hasUser() && this.user.isDistributor();
    }
  }
};
